// --------------------------------------------------------------------------
// application.js
// --------------------------------------------------------------------------
// This file imports and initialises modules.
//
// Add module names to the modules array for automatic initialisation.
//
// No specific javascript should be placed in this file.
// --------------------------------------------------------------------------
$(function () {
    "use strict";

    var modules = [
        "accordion",
        "ajaxForm",
        "autoFocus",
        "bannerSlider",
        "closeAlert",
        "datePicker",
        "enableSubmit",
        "enableTicketDetails",
        "enableVisitorSelect",
        "exhibitPopup",
        "exhibitsDate",
        "formValidate",
        "imageGallery",
        "megaNav",
        "numberField",
        "relativeTime",
        "responsiveNav",
        "select",
        "showTicketQty",
        "sponsors",
        "stickyAlert",
        "tabs",
        "ticketType",
        "timeSlider",
        "toggleAllFilters",
        "togglePopup",
        "toggleExperiences",
        "toggleMobileNav",
        "togglePassword",
        "faintFilterToggle",
        "timetable",
        "tooltip",
        "videoModal",
        "gallerySlider",
        "download",
        "tnew",
        "toggleCards",
        "quoteSlider",
        "modalContainer",
        "timedTicketing",
    ];

    for (var i = 0; i < modules.length; i++) {
        RN[modules[i]].init();
    }

    const whatsOnParents = $('[data-behaviour="whats-on"]');

    whatsOnParents.map(function (index, el) {
        RN["exhibitSlider"].init(el);
    });

    const shareEL = byBehaviour("sharetastic");
    if (shareEL && shareEL.length) {
        shareEL.sharetastic({
            sprite: "/application/themes/rawnet/app/images/vendor/sharetastic.svg",
            popup: true,
            services: {
                print: false,
                email: false,
                linkedin: false,
                tumblr: false,
                googleplus: false,
            },
        });
    }

    const formifyEl = byElement("formify");
    if (formifyEl && formifyEl.length) {
        formifyEl.formify();
    }

    byBehaviour("dismiss-popup").bind("click", function (e) {
        var $body = document.querySelector("body");
        $(this).parents('[data-element="popup"]').addClass("u-hidden");
        $body.style.removeProperty("overflow");
        $body.style.removeProperty("position");
        $body.style.removeProperty("top");
        $body.style.removeProperty("width");

        setCookie("popupDismissed", true, 1);
    });

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    }
});

RN.trueHover.init();
